import React, {createContext, useReducer} from 'react';
import DateTimeReducer from "./reducers/DateTimeReducer";
import dateTimeState from "./initialStates/dateTimeState";

export const DateTimeContext = createContext(null);

export const DateTimeProvider = ({children}) => {
    const [state, dispatch] = useReducer(DateTimeReducer, dateTimeState);
    return (
        <DateTimeContext.Provider value={{state, dispatch}}>
            {children}
        </DateTimeContext.Provider>
    );
};

